import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import AttributeCommand from '@ckeditor/ckeditor5-basic-styles/src/attributecommand';
export class AiPlugin extends Plugin {
    init() {
        const editor = this.editor;
        const ipexAiButton = 'aiButton';

        editor.ui.componentFactory.add(ipexAiButton, () => {
            const button = new ButtonView();
            button.set({
                withText: false,
                icon: '<svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M320 238.933333L213.333333 298.666667l59.733334-106.666667L213.333333 85.333333l106.666667 59.733334L426.666667 85.333333 366.933333 192 426.666667 298.666667 320 238.933333m512 418.133334L938.666667 597.333333l-59.733334 106.666667L938.666667 810.666667l-106.666667-59.733334L725.333333 810.666667l59.733334-106.666667L725.333333 597.333333l106.666667 59.733334M938.666667 85.333333l-59.733334 106.666667L938.666667 298.666667l-106.666667-59.733334L725.333333 298.666667l59.733334-106.666667L725.333333 85.333333l106.666667 59.733334L938.666667 85.333333m-369.493334 459.946667l104.106667-104.106667-90.453333-90.453333-104.106667 104.106667 90.453333 90.453333m43.946667-234.24l99.84 99.84c16.64 15.786667 16.64 43.52 0 60.16L215.04 968.96c-16.64 16.64-44.373333 16.64-60.16 0l-99.84-99.84c-16.64-15.786667-16.64-43.52 0-60.16L552.96 311.04c16.64-16.64 44.373333-16.64 60.16 0z" fill="" /></svg>',
                class: 'ck-ai-button',
                label: ipexAiButton,
                tooltip: '',
                isVisible: true
            });

            // we need to catch this command later
            editor.commands.add(ipexAiButton, new AttributeCommand(editor, ipexAiButton));

            // executing ai button
            button.on('execute', () => {
                editor.fire('onAiButtonClick');
            });

            return button;
        });
    }
}
